/* Keeps the buy panel honest when a product has options: pick the matching
   variant, update the price, and disable the button if that combination is not
   available. Products with a single variant need none of this. */
(function () {
  function init() {
    var form = document.getElementById('cji-fb-form');
    var tag = document.getElementById('cji-fb-variants');
    if (!form || !tag) return;
    var variants;
    try { variants = JSON.parse(tag.textContent); } catch (e) { return; }
    var vid = document.getElementById('cji-fb-vid');
    var price = document.getElementById('cji-fb-price');
    var add = document.getElementById('cji-fb-add');
    form.addEventListener('change', function () {
      var vals = Array.prototype.map.call(
        form.querySelectorAll('.cji-fb-select'), function (s) { return s.value; });
      var want = vals.join(' / ');
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].t === want) {
          vid.value = variants[i].id;
          var money = '$' + (variants[i].p / 100).toFixed(2)
                              .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
          if (price) price.textContent = money;
          var barP = document.getElementById('cji-fb-bar-price');
          if (barP) barP.textContent = money;
          [add, document.getElementById('cji-fb-bar-btn')].forEach(function (b) {
            if (!b) return;
            b.disabled = !variants[i].a;
            b.textContent = variants[i].a ? 'Add to cart' : 'Unavailable';
          });
          return;
        }
      }
    });
  }
  function stickyBar() {
    var bar = document.getElementById('cji-fb-bar');
    var add = document.getElementById('cji-fb-add');
    if (!bar || !add || !('IntersectionObserver' in window)) return;
    // Show the bar only once the real button has scrolled away, so it never
    // duplicates a button the customer can already see.
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      bar.classList.toggle('show', !visible);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { rootMargin: '0px 0px -40px 0px' }).observe(add);
  }
  function boot() { init(); stickyBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
